import { c as _c } from "react/compiler-runtime";
import { Card, CardHeader, CardBody, CardFooter, Button } from "@heroui/react";
import Image from "next/image";
import BarImage from "../BarImage";
interface InfoCardProps {
  title: string;
  subtitle?: string;
  pid: number;
  content: React.ReactNode;
  src?: string;
  footer?: React.ReactNode;
  action?: React.ReactNode;
  actionText?: string;
  chart?: React.ReactNode;
}
export default function InfoCard(t0) {
  const $ = _c(26);
  const {
    title,
    subtitle,
    content,
    pid,
    chart,
    src,
    action,
    actionText,
    footer
  } = t0;
  let t1;
  if ($[0] !== title) {
    t1 = <h4 className="text-white/90 font-medium text-">{title}</h4>;
    $[0] = title;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== subtitle) {
    t2 = subtitle && <p className="text-tiny text-white/60">{subtitle}</p>;
    $[2] = subtitle;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t1 || $[5] !== t2) {
    t3 = <CardHeader className="z-10 top-1 flex-col items-start pb-0">{t1}{t2}</CardHeader>;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== chart || $[8] !== pid || $[9] !== src) {
    t4 = chart ? chart : <BarImage url={src} pool={pid} />;
    $[7] = chart;
    $[8] = pid;
    $[9] = src;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== t4) {
    t5 = <div className="m-auto">{t4}</div>;
    $[11] = t4;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== content) {
    t6 = <div className="m-auto align-middle">{content}</div>;
    $[13] = content;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== t5 || $[16] !== t6) {
    t7 = <CardBody><div className="flex flex-row justify-center align-middle items-center content-center p-1">{t5}{t6}</div></CardBody>;
    $[15] = t5;
    $[16] = t6;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  let t8;
  if ($[18] !== action || $[19] !== actionText || $[20] !== footer) {
    t8 = action ? <CardFooter className="bg-black/50 bottom-0 border-t-1 border-zinc-100/50 z-10 justify-between align-middle py-[4px]">{actionText && <div className="flex text-xs align-middle pt-0 text-clip overflow-hidden"><span className="text-clip overflow-hidden">{actionText}</span></div>}<div className="flex align-middle">{action}</div></CardFooter> : footer && <CardFooter className="bg-black/50 border-t-1 border-zinc-100/50 z-10"><div className="align-baseline m-auto">{footer}</div></CardFooter>;
    $[18] = action;
    $[19] = actionText;
    $[20] = footer;
    $[21] = t8;
  } else {
    t8 = $[21];
  }
  let t9;
  if ($[22] !== t3 || $[23] !== t7 || $[24] !== t8) {
    t9 = <><Card isFooterBlurred={true} className="w-full cards-nftstakeinfo">{t3}{t7}{t8}</Card></>;
    $[22] = t3;
    $[23] = t7;
    $[24] = t8;
    $[25] = t9;
  } else {
    t9 = $[25];
  }
  return t9;
}